/**
 * Events data — single source of truth for all upcoming/past events.
 * Add new events by appending to the EVENTS array below. Set `featured: true`
 * to have them appear on the homepage's Upcoming Events section.
 *
 * Image resolution:
 *   - Drop the flyer at /app/frontend/public/events/{slug}.jpg (or .png)
 *   - Set `image: "/events/{slug}.jpg"` below
 *   - If the file is missing, EventCard falls back to a premium gradient hero
 *     built from the event's accent color + title.
 */

export const EVENTS = [
  {
    slug: "we-flight-school-week-4",
    title: "WE Flight School — Week 4",
    subtitle: "Teamwork & Culture",
    tagline: "Building Strong Teams · Workplace Culture · Collaboration · Trust",
    description:
      "A high-impact live virtual session on the pillars of high-performing teams. Learn how to build trust, strengthen communication, and create a workplace culture where people do their best work.",
    image: "/events/we-flight-school-week-4.png",
    accent: "purple", // maps to gradient in EventCard
    format: "Live Virtual Session",
    formatBadge: "Virtual",
    startISO: "2026-07-04T17:00:00Z", // 10:00 AM PT = 17:00 UTC (PDT summer)
    endISO: "2026-07-04T18:30:00Z",
    dateLabel: "Saturday, July 4, 2026",
    timeLabel: "10:00 AM – 11:30 AM PT",
    location: "Live Virtual",
    hostedBy: "Brandon Ward",
    highlights: [
      "Build Stronger Teams",
      "Strengthen Communication",
      "Create Positive Culture",
      "Lead With Trust",
    ],
    ctaPrimary: {
      label: "Register Now",
      href: "https://www.thewementality.com/event-details/we-flight-school-week-4-teamwork-culture",
    },
    ctaSecondary: {
      label: "Learn More",
      href: "https://www.thewementality.com/event-details/we-flight-school-week-4-teamwork-culture",
    },
    featured: true,
    tags: ["Leadership Training", "Team Building", "Culture"],
  },
  {
    slug: "youth-ceo-camp-2026",
    title: "Youth CEO Camp",
    subtitle: "Lemonade Stand Business Plan Bootcamp",
    tagline: "Leadership · Entrepreneurship · Financial Literacy · Public Speaking",
    description:
      "An immersive entrepreneurship experience where youth learn leadership, financial literacy, business planning, marketing, teamwork, communication, and public speaking — while building and pitching a real business.",
    image: "/events/youth-ceo-camp.png",
    accent: "gold",
    format: "In-Person Bootcamp",
    formatBadge: "In-Person",
    startISO: "2026-07-29T15:00:00Z", // 8:00 AM PT = 15:00 UTC
    endISO: "2026-08-01T20:00:00Z",
    dateLabel: "July 29 – August 1, 2026",
    timeLabel: "Wed–Fri: 8:00 AM – 1:00 PM · Sat: Pitch Day Showcase",
    location: "Urban Chamber of Commerce",
    locationDetail: "1951 Stella Lake St, Las Vegas, NV 89106",
    ageRange: "Ages 10–17 (7–9 may attend with a parent/guardian)",
    capacity: "Limited to 20 participants",
    hostedBy: "Brandon Ward",
    highlights: [
      "Leadership",
      "Entrepreneurship",
      "Financial Literacy",
      "Marketing",
      "Business Planning",
      "Public Speaking",
      "Teamwork",
    ],
    ctaPrimary: {
      label: "Reserve My Seat",
      href: "https://www.chamberorganizer.com/members/evr/reg_main.php?orgcode=URBN&evid=102933627",
    },
    ctaSecondary: {
      label: "Program Details",
      href: "https://www.chamberorganizer.com/members/evr/reg_main.php?orgcode=URBN&evid=102933627",
    },
    featured: true,
    tags: ["Youth Entrepreneurship", "Business Bootcamp", "Las Vegas"],
  },
];

const isUpcoming = (e) => e.published !== false && new Date(e.endISO || e.startISO) > new Date();
export const getFeaturedEvents = () => EVENTS.filter((e) => e.featured && isUpcoming(e));
export const getUpcomingEvents = () => EVENTS.filter(isUpcoming);
export const getEventBySlug = (slug) => EVENTS.find((e) => e.slug === slug);
